import { GetItemCounts } from '@ukpostbox/client-data';
import { useInfiniteSendMailBox } from '@ukpostbox/client-data/lib/Wrappers/ReactQuery/Endpoints/SendMail';
import {
	PageHeader,
	ContentBlock,
	ContentLoader,
	InfiniteLoadTrigger,
	ItemRowHeader,
	useLayout,
	ContentSidebarLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useRef, useState } from 'react';
import SendsHistoryItem from '../../SendsProfiles/ProfilesAdmin/Components/SendsHistoryItem';
import { useSite } from '../../_Global/Providers/SiteInterfaceProvider';
import SendsNavigation from '../Components/Shared/Controls/SendsNavigation';

function SendMail() {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();
	const { currentLocale, updatePageMeta } = useSite();

	const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 });

	const {
		status,
		data,
		error,
		isFetchingNextPage,
		fetchNextPage,
		hasNextPage,
		dataUpdatedAt,
		isStale,
		isRefetching,
	} = useInfiniteSendMailBox();

	const sendMailRef = useRef<any>(null);
	const sendMailNavigationRef = useRef<any>(null);

	useEffect(() => {
		if (data) {
			setItemCounts(GetItemCounts(data as any));
		}
	}, [dataUpdatedAt, data]);

	useEffect(() => {
		updatePageMeta({
			title: t('sends.history.title'),
		});
	}, [currentLocale]);

	return (
		<ContentSidebarLayout
			ref={sendMailRef}
			navigationComponent={
				<SendsNavigation
					ref={sendMailNavigationRef}
					title={t('sends.history.title')}
					/*                        addonContent={
                            <>
                                {!isLarge && (
                                    <>
                                        <div className={'section-navigation-header-collapsed-addon'}>
                                            <SendHistoryFilterButton />
                                        </div>
                                        <SendsHistoryFilterControl />
                                    </>
                                )}
                            </>
                        } */
				/>
			}
			extraContentClass='flex-column sends-single-history-rows'
		>
			{!isTiny && !isSmall && !isMedium && (
				<PageHeader title={t('sends.history.title')} extraClass='section-page-header' />
			)}

			{isTiny ||
				(isSmall && (
					<ItemRowHeader title='Sends History' sticky extraClass='pl-lg'>
						<div>{t('sends.history.headings.file')}</div>
						<div>{t('sends.history.headings.sentId')}</div>
						<div>{t('sends.history.headings.address')}</div>
						<div>{t('sends.history.headings.postage')}</div>
						<div>{t('sends.history.headings.date')}</div>
					</ItemRowHeader>
				))}

			{status === 'pending' ? (
				<ContentLoader childHeight='7em' />
			) : status === 'error' ? (
				<ContentBlock error title={error.name} content={error.message} />
			) : (
				<>
					{data.pages.map((group, groupIndex) =>
						group.data.map((sentItem: any, index) => (
							<SendsHistoryItem
								hideUserDetails
								id={sentItem.mailUuid}
								title={sentItem.itemReference}
								liveUrl={`/mail/sends/${sentItem.mailUuid}`}
								user={{
									id: '1',
									name: 'name',
									emailAddress: 'email',
								}}
								dateCreated={sentItem.dateUploaded}
								isDeleted={false}
								mailItem={{
									mailUuid: sentItem.mailUuid,
									trackingId: sentItem.itemReference,
									dateReceived: sentItem.dateUploaded,
									dateRead: sentItem.dateUploaded,
									dateUpdated: sentItem.dateUpdated,
									mailAction: {
										key: 'string',
										description: 'string',
										status: 'string',
										requiresUserInput: false,
									},
									mailType: 1,
									files: sentItem.files,
									daysUntilNextStorageCharge: null,
									orderByDate: sentItem.dateUpdated,
									actions: [],
								}}
								postageOption={{
									id: sentItem.postageOption.id,
									name: sentItem.postageOption.optionName,
								}}
								address={sentItem.clientAddress}
							/>
						)),
					)}

					<InfiniteLoadTrigger
						loaded={itemCounts.loaded}
						totalCount={itemCounts.total}
						hasNextPage={hasNextPage}
						fetchNextPage={fetchNextPage}
						isStale={isStale}
						isRefetching={isRefetching}
						isFetchingNextPage={isFetchingNextPage}
					/>
				</>
			)}
		</ContentSidebarLayout>
	);
}

export default SendMail;
